<!-- Affichage dans le cas d'une étape future (qui n'a pas encore été atteinte) -->
@if (currentStateId === 'N/A') {
    <span>-</span>
}

<!-- Affichage lorsque l'état courant est le dernier état de l'étape. Dans ce cas, l'état n'est plus éditable -->
@if (completed === true) {
    <span>{{ currentStateName }}</span>
}

<!-- Affichage lorsque l'état courant n'est pas le dernier état de l'étape. Dans ce cas, l'état est éditable -->
@if (!readonly) {
    @if (currentStateId !== 'N/A' && completed === false) {
        <mat-select (selectionChange)="onUpdateState($event.value)" [value]="currentStateId">
            @for (state of states; track state.id) {
                <mat-option [value]="state.id.toString()">{{ state.name }}</mat-option>
            }
        </mat-select>
    }
} @else {
    @if (currentStateId !== 'N/A' && completed === false) {
        <span>{{ currentStateName }}</span>
    }
}
